var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#487FC7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 28.0843C42 20.3531 35.7313 14.0844 28 14.0844C20.2688 14.0844 14 20.3531 14 28.0843C14 35.0718 19.1188 40.8637 25.8125 41.915V32.1325H22.2569V28.0843H25.8125V25C25.8125 21.4918 27.9031 19.5525 31.1006 19.5525C32.6325 19.5525 34.235 19.8262 34.235 19.8262V23.2718H32.4688C30.7306 23.2718 30.1869 24.3506 30.1869 25.4593V28.0843H34.0694L33.4494 32.1325H30.1875V41.9162C36.8813 40.8656 42 35.0737 42 28.0843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fbLogo.004015ed68c2a7d1438cdeefedee78de.svg";
export { ForwardRef as ReactComponent };